import { render, staticRenderFns } from "./InterfaceRepeat.vue?vue&type=template&id=47b19fe0&scoped=true"
import script from "./InterfaceRepeat.vue?vue&type=script&lang=js"
export * from "./InterfaceRepeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b19fe0",
  null
  
)

export default component.exports